// --- Hooks ---
import { useTiptapEditor } from "@/tiptap/hooks/use-tiptap-editor"

// --- Lib ---
import { isNodeTypeSelected } from "@/tiptap/lib/tiptap-utils"

// --- Tiptap UI ---
import { DeleteNodeButton } from "@/tiptap/ui/delete-node-button"
import { ImageDownloadButton } from "@/tiptap/ui/image-download-button"
import { ImageAlignButton } from "@/tiptap/ui/image-align-button"
import { ImageBorderButton } from "@/tiptap/ui/image-border-button"
import { ImageInlineToggleButton } from "@/tiptap/ui/image-inline-toggle-button"

// --- UI Primitive ---
import { Separator } from "@/tiptap/ui-primitive/separator"
import { ImageCaptionButton } from "@/tiptap/ui/image-caption-button"
import { ImageUploadButton } from "@/tiptap/ui/image-upload-button"
import { RefreshCcwIcon } from "@/tiptap/icons/refresh-ccw-icon"

export function ImageNodeFloating({
  editor: providedEditor
}) {
  const { editor } = useTiptapEditor(providedEditor)
  const blockSelected = isNodeTypeSelected(editor, ["image"])
  const inlineSelected = isNodeTypeSelected(editor, ["inlineImage"])

  if (!editor || (!blockSelected && !inlineSelected)) {
    return null
  }

  // Inline images have no caption, alignment or border; offer only the way
  // back to a block image and delete.
  if (inlineSelected) {
    return (
      <>
        <ImageInlineToggleButton />
        <Separator />
        <DeleteNodeButton />
      </>
    );
  }

  return (
    <>
      <ImageAlignButton align="left" />
      <ImageAlignButton align="center" />
      <ImageAlignButton align="right" />
      <Separator />
      <ImageCaptionButton />
      <ImageBorderButton />
      <ImageInlineToggleButton />
      <Separator />
      <ImageDownloadButton />
      <ImageUploadButton icon={RefreshCcwIcon} tooltip="Replace" />
      <Separator />
      <DeleteNodeButton />
    </>
  );
}
